<template>
  <div class="TVChartContainer" ref="chartContainer" />
</template>
<script>
import { mapGetters, mapState } from 'vuex'
import { widget } from 'charting_library'
import { dataFeedObject } from './api'
import { getTradingChartTimezone } from './timezone'
import { stdTimezoneOffset } from './helpers'
import { customWidgetOptions } from './colorTheme'

export default {
  name: 'TVChartContainer',
  data() {
    return {
      tvWidget: null,
      currentKlineSubscription: {},
      mostRecentBar: null,
      allBars: [],
      colorTheme: 'light',
      libraryPath: '/charting_library/',
      tradeSubscription: null,
      recentResolution: null,
      recentBarChanged: false,
      recentlyAdded: [],
      intervalId: null,
      unwatch: null,
      realTimeCallBack: undefined,
      resolveSymbolTimeout: null,
    }
  },
  destroyed() {
    if (this.tvWidget !== null) {
      this.tvWidget.remove()
      this.tvWidget = null
    }
  },
  mounted() {
    if (this.brand && this.user) {
      this.init()
    }
  },
  computed: {
    ...mapState('common', ['sbState', 'dark']),
    ...mapState('brand', ['brand', 'stockType']),
    ...mapGetters('trade', [
      'newTrade'
    ]),
    ...mapState('user', ['user']),
  },
  methods: {
    appendTrade(RealTimeCallBack, newValue) {
      if (newValue.size && newValue.price) {
        let bar = this.mostRecentBar
        const { price, size } = newValue
        let now = new Date()
        if (!bar) {
          bar = {}
          bar['high'] = price
          bar['open'] = price
          bar['close'] = price
          bar['low'] = price
          bar['time'] = now.getTime()
          bar['volume'] = parseInt(size)
        } else {
          bar['high'] = price > bar.high ? price : bar.high;
          bar['low'] = price < bar.low ? price : bar.low;
          bar['close'] = price;
          // bar['time'] = bar.time < now.getTime() ? now.getTime() : bar['time'];
          bar['volume'] = parseInt(bar['volume']) + parseInt(size)
        }

        this.mostRecentBar = bar
        // console.debug('(TradeChart) Deep cloned this.mostRecentBar: ', this.mostRecentBar)
        this.recentBarChanged = true
        RealTimeCallBack(this.mostRecentBar)
      }
    },
    // ᢈᠡᠨ ᠨᠢᢉᠡ ᠠᠴᠢ ᠲᠠᠢ ᠪᠤᠶᠠᠨᠲᠠᠢ ᢈᠦᠮᠦᠨ ᠪᠠᠶᠢᠪᠠᠯ ᠳᠠᠷᠠᠭ᠎ᠠ ᠵᠠᠰᠠᠭᠠᠷᠠᠢ᠃
    appendNewTrade(RealTimeCallBack) {
      this.unwatch = this.$watch(() => this.newTrade, (newValue, oldValue) => {
        console.log('WATCHING:', newValue);
        if (newValue.size && newValue.price) {
          let bar = this.mostRecentBar
          const { price, size } = newValue
          let now = new Date()
          if (!bar) {
            bar = {}
            bar['high'] = price
            bar['open'] = price
            bar['close'] = price
            bar['low'] = price
            bar['time'] = now.getTime()
            bar['volume'] = parseInt(size)
          } else {
            bar['high'] = price > bar.high ? price : bar.high;
            bar['low'] = price < bar.low ? price : bar.low;
            bar['close'] = price;
            // bar['time'] = bar.time < now.getTime() ? now.getTime() : bar['time'];
            bar['volume'] = parseInt(bar['volume']) + parseInt(size)
          }

          this.mostRecentBar = bar
          // console.debug('(TradeChart) Deep cloned this.mostRecentBar: ', this.mostRecentBar)
          this.recentBarChanged = true
          RealTimeCallBack(this.mostRecentBar)
        }
      })
    },
    async cent(RealTimeCallBack) {
      console.debug('(TradeChart) cent begins ...')

      if (this.tradeSubscription) await this.unsubscribeCent()
      if (this.connected) {
        console.debug('(TradeChart) cent is connected')

        try {
          this.tradeSubscription = this.instance.subscribe(
            `trade:${this.brand.symbol}`,
            async (msg) => {
              console.debug('(TradeChart) currentMarket: ', this.brand.symbol);
              console.debug('(TradeChart) msg: ', msg);

              let filteredTrade = []
              if (Array.isArray(msg.data)) {
                return;
              }

              console.log('TR Chart:')
              console.log(msg.data)

              /* If the MDEntryID is not found in recentlyAdded, the element is pushed into the filteredTrade array */
              msg.data.NoMDEntries.forEach((t) => {
                if (!this.recentlyAdded.find((e) => t.MDEntryID === e)) {
                  filteredTrade.push(t)
                }
              })

              /* If filteredTrade has elements */
              if (filteredTrade.length > 0) {
                /* Each element in filteredTrade is iterated over, and its MDEntryID is pushed into the recentlyAdded array. */
                filteredTrade.forEach((element) => {
                  this.recentlyAdded.push(element.MDEntryID)
                })

                console.debug('(TradeChart) filteredTrade.length: ', filteredTrade.length)
                console.debug('(TradeChart) filteredTrade: ', filteredTrade)
                console.debug('(TradeChart) this.recentlyAdded: ', this.recentlyAdded)
                console.debug('(TradeChart) this.recentlyAdded.length: ', this.recentlyAdded.length)

                /*
                * The filteredTrade array is passed as arguments to the pushTrades action in the Vuex store using ...filteredTrade
                * trades in store will be updated
                */
                await this.$store.dispatch('pushTrades', ...filteredTrade)

                /*
                * A deep clone of this.mostRecentBar is created and assigned to the bar variable
                * If certain conditions are met (
                *   msg.data.NoMDEntries[0] exists and
                *   it has MDEntryPx and
                *   MDEntrySize properties
                * ), a new object named recent is created with price and size properties extracted from msg.data.NoMDEntries[0]
                */
                let bar = _.cloneDeep(this.mostRecentBar)
                console.debug('(TradeChart) Deep cloned bar: ', bar)

                if (msg.data.NoMDEntries[0] && msg.data.NoMDEntries[0].MDEntryPx && msg.data.NoMDEntries[0].MDEntrySize) {
                  let recent = {
                    price: msg.data.NoMDEntries[0].MDEntryPx,
                    size: msg.data.NoMDEntries[0].MDEntrySize,
                  }
                  console.debug('(TradeChart) Pushing recent bar: ', recent)
                  let now = new Date()

                  if (recent.price > bar.high) {
                    bar.high = recent.price
                    console.debug('(TradeChart) recent.price > bar.high')
                  }

                  if (recent.price < bar.low) {
                    bar.low = recent.price
                    console.debug('(TradeChart) recent.price < bar.low')
                  }

                  if (bar.time < now.getTime()) {
                    bar.time = now.getTime()
                    console.debug('(TradeChart) bar.time < now.getTime()')
                  }

                  bar.volume = parseInt(recent.size) + parseInt(bar.volume)
                  this.mostRecentBar = _.cloneDeep(bar)
                  console.debug('(TradeChart) Deep cloned this.mostRecentBar: ', this.mostRecentBar)
                  this.recentBarChanged = true
                }
                RealTimeCallBack(bar)
              }
            }
          )
          // this.tradeSubscription.on('subscribe', (ctx) =>
          //   console.log('sub trade in chart', ctx)
          // )
        } catch (e) {
          console.error(e)
        }
      }
    },
    setChart() {
      this.clearRecentBarValues()

      const container = this.$refs.chartContainer
      const currentTimeOffset = new Date().getTimezoneOffset()
      const clockPeriod =
          currentTimeOffset === stdTimezoneOffset(new Date()) ? 'STD' : 'DST'
      const disabledFeatures = {
        disabled_features: [
          'use_localstorage_for_settings',
          'header_symbol_search',
          'header_compare',
          'header_undo_redo',
          'header_screenshot',
          'header_settings',
          'hide_resolution_in_legend',
          'timezone_menu',
          'countdown',
          'source_selection_markers',
          'timeframes_toolbar',
          'volume_force_overlay',
        ],
      }
      const widgetOptions = {
        symbol: this.brand.symbol,
        datafeed: dataFeedObject(this, [this.brand]),
        interval: '60',
        container: container,
        locale: 'en',
        library_path: this.libraryPath,
        allow_symbol_change: false,
        autosize: true,
        calendar: true,
        client_id: 'tradingview.com',
        // custom_css_url: '/css/tradingview.css',
        // charts_storage_url: 'https://saveload.tradingview.com',
        charts_storage_url: 'https://trader.ucc.mn/api/tradeview',
        charts_storage_api_version: '1',
        debug: false,
        // range: '20D',
        details: true,
        enable_publishing: false,
        enabled_features: ['show_animated_logo'],
        fullscreen: false,
        height: 610,
        hide_side_toolbar: false,
        hotlist: true,
        popup_height: '50',
        popup_width: '000',
        show_popup_button: true,
        studies_overrides: {},
        user_id: this.user.id,
        timezone: getTradingChartTimezone(currentTimeOffset, clockPeriod),
        ...disabledFeatures,
        ...customWidgetOptions(this.colorTheme),
      }
      this.tvWidget = new widget(widgetOptions)
      this.tvWidget.onChartReady(() => {

        const setLastDaysRange = () => {
          const now = new Date();
          const to = Math.floor(now.getTime() / 1000); // Current time in seconds
          const from = to - (10 * 24 * 60 * 60); // 10 days ago in seconds

          this.tvWidget.chart().setVisibleRange({
            from: from,
            to: to
          });
        };

        setLastDaysRange();
        this.tvWidget.chart().onSymbolChanged().subscribe(null, setLastDaysRange);
        this.tvWidget.chart().onIntervalChanged().subscribe(null, setLastDaysRange);

        this.tvWidget
            .activeChart()
            .setSymbol(this.brand.symbol)
      })
    },
    timedEvent(RealTimeCallBack, resolution) {
      this.recentResolution = resolution
      this.intervalId = setInterval(() => {
        // console.debug('(TradeChart) TradeChart -> timedEvent')

        let bar = _.cloneDeep(this.mostRecentBar)
        // console.debug('(TradeChart) Deep cloned bar: ', bar)

        bar.time = ((bar.time + resolution) / 60) * 60
        if (this.recentBarChanged) {
          // console.debug('(TradeChart) RecentBarChanged: ', this.recentBarChanged)
          bar.volume = 0
          bar.high = bar.close
          bar.low = bar.close
          bar.open = bar.close
        }
        this.mostRecentBar = _.cloneDeep(bar)
        // console.debug('(TradeChart) Deep cloned this.mostRecentBar: ', this.mostRecentBar)
        RealTimeCallBack(bar)
      }, resolution)
    },
    unsubscribeTimedEvent() {
      clearInterval(this.intervalId)
      this.intervalId = null
    },
    clearRecentBarValues() {
      this.recentlyAdded = []
      this.mostRecentBar = null
      this.recentResolution = null
      this.allBars = []
    },
    async unsubscribeCent() {
      if (this.tradeSubscription) {
        await this.tradeSubscription.unsubscribe()
        this.tradeSubscription = null
        this.clearRecentBarValues()
      }
    },

    init() {
      this.clearRecentBarValues()
      this.setChart()
    }
  },
  watch: {
    brand(brand) {
      this.init()
    },
    user(user) {
      this.init()
    },
    // mostRecentBar: {
      // handler() {
      // console.debug('(TradeChart) Watch -> this.mostRecentBar has changed', this.mostRecentBar)
      // },
    // },
    newTrade: {
      handler(newValue) {
        if (newValue.size && newValue.price) {
          let bar = this.mostRecentBar
          const { price, size } = newValue
          let now = new Date()

          if (!bar || (typeof bar['time'] !== 'undefined' && bar['time'] < now.getTime())) {
            bar = {}
            bar['high'] = price
            bar['open'] = price
            bar['close'] = price
            bar['low'] = price
            bar['time'] = now.getTime()
            bar['volume'] = parseInt(size)
          } else {
            bar['high'] = price > bar.high ? price : bar.high;
            bar['low'] = price < bar.low ? price : bar.low;
            bar['close'] = price;
            // bar['time'] = bar.time < now.getTime() ? now.getTime() : bar['time'];
            bar['volume'] = parseInt(bar['volume']) + parseInt(size)
          }

          this.mostRecentBar = bar
          this.recentBarChanged = true
          if (this.realTimeCallBack) this.realTimeCallBack(this.mostRecentBar)
        }
      }
    },
    colorTheme: {
      handler(val) {
        this.setChart()
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.TVChartContainer {
  height: calc(100vh * 0.6);
}
</style>
